import { useEffect } from "react";
import { View } from "react-native";
import { Slot, useRouter } from "expo-router";
import styled from "styled-components/native";
import { useAppSelector } from "@/_hooks";
import ServiceLogo from "@/assets/icons/auth/serviceLogo.svg";
import AlertIcon from "@/assets/icons/main/redAlert.svg";
import { toast } from "sonner-native";
import { getErrorMessage } from "@/_utils/getErrorMessage";

const AuthLayout = () => {
  const { error } = useAppSelector((state) => state.account);

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(error) || "При входе в систему произошла ошибка";

      toast.error(errorMessage, {
        icon: <AlertIcon />,
        duration: 5000,
      });
    }
  }, [error]);

  return (
    <Container>
      <Wrapper>
        <View>
          <LogoContainer>
            <ServiceLogo width={180} height={32} />
          </LogoContainer>
          <BackgroundLayout>
            <Slot />
          </BackgroundLayout>
        </View>

        <Footer>
          <SupportLabel>Служба поддержки:</SupportLabel>
          <SupportContacts>8 (800) 700-04-25</SupportContacts>
          <SupportContacts>helpme@bizguard.ru</SupportContacts>
        </Footer>
      </Wrapper>
    </Container>
  );
};

export default AuthLayout;


const Container = styled.View`
  background-color: #fff;
  margin: 0 auto;
  height: 100%;
`;

const Wrapper = styled.ScrollView.attrs({
  contentContainerStyle: {
    flexGrow: 1,
    justifyContent: "space-between"
  }
})`
  flex: 1;
`;

const LogoContainer = styled.View`
  align-items: center;
  padding-top: 44px;
  padding-bottom: 64px;
`;


const BackgroundLayout = styled.View`
  width: 100%;
`;

const Footer = styled.View`
  align-items: center;
  margin-bottom: 36px;
`;

const SupportLabel = styled.Text`
  font-size: 16px;
  color: #6b7280;
  font-weight: 400;
  margin-bottom: 12px;
`;

const SupportContacts = styled.Text`
  font-size: 16px;
  color: #101928;
  font-weight: 400;
  margin-bottom: 8px;
`;
